export default __webpack_public_path__ + "static/media/play-circle.6f25d910.svg";